import { useSettings } from "@/lib/settings";
import { useLanguage } from "@/lib/i18n";

// Fields that have an "_en" localized variant in Settings
const LOCALIZED_FIELDS = [
  "tagline",
  "slogan",
  "hero_description",
  "tagline_bottom",
  "footer_note",
  "copyright_text",
  "promo_sticker_headline",
  "promo_sticker_subline",
  "imprint_additional",
];

/**
 * useLocalizedSettings – returns the settings object with all localized
 * fields swapped to their `_en` version when the active language is English.
 * Empty EN fields fall back to the German source.
 */
export function useLocalizedSettings() {
  const s = useSettings();
  const { lang } = useLanguage();
  if (lang !== "en" || !s) return s;

  const out = { ...s };
  for (const key of LOCALIZED_FIELDS) {
    const en = s[`${key}_en`];
    if (en && String(en).trim().length > 0) {
      out[key] = en;
    }
  }
  return out;
}
